import {
  Button,
  Divider,
  Footer as FooterComponent,
  SocialProps,
  Socials,
  Typography,
  TypographyMods,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

import { Image } from '~components/Image/Image';
import { ImageProps } from '~components/Image/Image.types';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { Goals } from '~services/Goals';
import { URLS } from '~types/Urls.types';

import styles from './FooterHrTek.module.scss';
import { FooterHrTekProps } from './FooterHrTek.types';

export function FooterHrTek({
  logo,
  logoVkTech,
  socials,
  contacts,
  appLink,
  columns,
  address,
  copyright,
  agreement,
  text,
}: FooterHrTekProps) {
  const [, { isDesktop, isMobile }] = useBreakpoints();
  const today = new Date();
  const year = today.getFullYear();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    Goals.gtag4({ event: 'entrance_lk' });
    Goals.ym({
      event: 'reachGoal',
      action: 'entrance_lk',
    });

    const newWindow = window.open(
      appLink?.url || '',
      '_blank',
      'noopener,noreferrer',
    );
    if (newWindow) newWindow.opener = null;
  };

  return (
    <>
      <Divider className={styles.divider} />
      <FooterComponent
        className={styles.footer}
        logo={logo as ImageProps}
        columns={columns?.[0]?.items}
        additionalButtons={
          <Button
            className={styles.button}
            size={isDesktop ? 'm' : 's'}
            href={appLink?.url || ''}
            onClick={handleClick}
            target="_blank"
            mod="invert"
          >
            {appLink?.icon && <Image {...appLink.icon} alt="" />}
            {appLink?.text}
          </Button>
        }
        customBottomSection={
          <div className={styles.bottomWrapper}>
            <div className={styles.rowWrapper}>
              <div className={styles.contactsWrapper}>
                {logoVkTech && (
                  <a className={styles.logo} href={URLS.Vktech} target="_blank">
                    <Image
                      {...logoVkTech}
                      className={styles.logo}
                      alt="VK Tech"
                    />
                  </a>
                )}
                {contacts && (
                  <div className={styles.contacts}>
                    {contacts?.map((contact, index) => (
                      <React.Fragment key={contact.id}>
                        {index !== 0 && <span className={styles.dot} />}
                        <Link href={contact.url}>
                          <Typography
                            mods={[TypographyMods.bodyS]}
                            className={classNames({
                              [styles.phone]: contact.url.includes('tel:'),
                              [styles.email]: contact.url.includes('mailto:'),
                            })}
                          >
                            {contact.title}
                          </Typography>
                        </Link>
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
              {!isMobile && socials?.length && (
                <Socials items={socials as SocialProps[]} />
              )}
            </div>
            <div className={styles.rowWrapper}>
              <div className={styles.copyright}>
                <Typography mods={[TypographyMods.bodyS]}>
                  {copyright && copyright.replace('{{year}}', String(year))}
                </Typography>
                <Typography mods={[TypographyMods.bodyS]}>{text}</Typography>
              </div>
              {agreement?.url && (
                <Link className={styles.contentAgreement} href={agreement.url}>
                  <Typography mods={[TypographyMods.bodyS]}>
                    {agreement.title}
                  </Typography>
                </Link>
              )}
              <Typography
                className={styles.address}
                mods={[TypographyMods.bodyS]}
              >
                {address}
              </Typography>
            </div>
            {isMobile && socials && (
              <Socials items={socials as SocialProps[]} />
            )}
          </div>
        }
      />
    </>
  );
}
